
import { renderSymbol } from 'helpers/renderSymbol';
import PropTypes from 'prop-types';
import React from 'react';

const TrendTooltipPointValueRow = ({ point, uom }) => {
    const pointValue = point.y;
    const symbolName = point?.series?.options?.marker?.symbol ?? point?.point?.series?.symbol;

    return (
        <>
            {
                point.series.userOptions.component &&
                <div><b>{point.series.userOptions.component}</b></div>
            }
            {/* <span className='symbol' style={{ backgroundColor: point.color, opacity: '1' }} /> */}
            <span className='symbol' style={{ color: point.color, opacity: '1' }} >{renderSymbol(symbolName)}</span>
            <span>{` ${point.series.name}: ${pointValue} ${uom}`}</span>
        </>
    );
};

TrendTooltipPointValueRow.propTypes = {
    point: PropTypes.shape({
        color: PropTypes.string,
        series: PropTypes.shape({
            name: PropTypes.string,
            userOptions: PropTypes.shape({
                allSignal: PropTypes.bool,
                component: PropTypes.string
            })
        }),
        y: PropTypes.number
    }),
    uom: PropTypes.string
};

export default TrendTooltipPointValueRow;
